import { PROJECT_CREATE_PERMISSIONS } from "@/lib/permissions";
export type NewItemKey = "time" | "ticket" | "article" | "project" | "escalation";

/** Which "New" items a person gets, in menu order. Time first: it is what most people do most often. */
export function newMenuItems(permissions: readonly string[]): NewItemKey[] {
  const has = (p: string) => permissions.includes(p);
  const items: NewItemKey[] = [];
  if (has("time:log")) items.push("time");
  if (has("tickets:create")) items.push("ticket");
  if (has("articles:create")) items.push("article");
  if (has("escalations:create")) items.push("escalation");
  if (PROJECT_CREATE_PERMISSIONS.some(has)) items.push("project");
  return items;
}
